export const SIGN_REQUEST = "Sign.Request";
export const SIGN_SUCCESS = "Sign.Success";
export const SIGN_FAILURE = "Sign.Failure";
export const SIGN_RESET = "Sign.Reset";


export function signDocs(docs: Array<string>, key: Key, sync = true) {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: SIGN_REQUEST });
    return fetch("/api/sign", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ docs, key, async: !sync }),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        if (!sync) {
          data.result = {
            list: docs.map((id) => {
              return { id, error: { code: 115 } };
            }),
            more: false,
          };
        }
        dispatch({
          type: SIGN_SUCCESS,
          payload: data.result,
        });
      } else {
        dispatch({
          type: SIGN_FAILURE,
          payload: data,
        });
      }
    });
  }
}
